import { render, staticRenderFns } from "./TaskCommentDialog.vue?vue&type=template&id=37996fee"
import script from "./TaskCommentDialog.vue?vue&type=script&lang=js"
export * from "./TaskCommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports